// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";
import CenteredBlogCard from "examples/Cards/BlogCards/CenteredBlogCard";

// Images
import image from "assets/images/2.png";

function Information() {
  return (
    <MKBox component="section" py={12}>
      <Container>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} lg={6}>
            <Grid container justifyContent="flex-start">
              <Grid item xs={12} md={6}>
                <MKBox mb={5}>
                  <DefaultInfoCard
                    icon="flag"
                    title="Mission"
                    description="Our mission is to empower businesses with innovative software solutions, driving digital transformation and delivering exceptional value through cutting-edge technology."
                  />
                </MKBox>
              </Grid>
              <Grid item xs={12} md={6}>
                <MKBox mb={5}>
                  <DefaultInfoCard
                    icon="public"
                    title="Vision"
                    description="To be a global leader in software development, setting the standard for excellence and innovation in creating impactful solutions that shape the future of technology."
                  />
                </MKBox>
              </Grid>
              <Grid item xs={12} md={6}>
                <MKBox mb={5}>
                  <DefaultInfoCard
                    icon="build"
                    title="Services"
                    description="We offer a comprehensive range of services, including custom software development, mobile app creation, web development, and cloud solutions tailored to your business needs."
                  />
                </MKBox>
              </Grid>
              <Grid item xs={12} md={6}>
                <MKBox mb={5}>
                  <DefaultInfoCard
                    icon="lightbulb"
                    title="Expertise"
                    description="Our team of experts specializes in diverse technologies, ensuring top-notch solutions in AI, machine learning, cloud computing, and scalable web and mobile applications."
                  />
                </MKBox>
              </Grid>
              <Grid item xs={12} md={6}>
                <MKBox mb={5}>
                  <DefaultInfoCard
                    icon="persons"
                    title="Founder's Story"
                    description="Founded by passionate tech enthusiasts, our journey began with a vision to bridge the gap between innovation and practical solutions, transforming ideas into reality."
                  />
                </MKBox>
              </Grid>
              <Grid item xs={12} md={6}>
                <MKBox mb={5}>
                  <DefaultInfoCard
                    icon="star"
                    title="Success Stories"
                    description="We've empowered numerous clients with successful digital transformations, delivering impactful solutions that drive growth, enhance efficiency, and foster long-term partnerships."
                  />
                </MKBox>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} lg={4.2} sx={{ ml: "auto", mt: { xs: 3, lg: 0 } }}>
            <CenteredBlogCard
              image={image}
              title="Get insights on Search"
              description="Website visitors today demand a frictionless user experience — especially when using search. Because of the high standards."
              action={{
                type: "internal",
                route: "pages/company/about-us",
                color: "info",
                label: "find out more",
              }}
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Information;
